<template>
  <div id="loading">
    <router-link :to="{ name: 'index'}">
      <svgicon name="logo" height="150" width="350" :original="true"></svgicon>
    </router-link>
    <p class="logo-text">GamePlan</p>
    <loader :showLoader="true" />
    <p v-if="message">
      {{ message }}
    </p>
    <div class="level">
      <div class="level-left digita-production">
        <svgicon class="level-item" name="shield" height="20" color="#63CCCA"></svgicon>
        <p class="level-item">a Digita Security Production</p>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';

export default {
  name: 'Loading',
  components: {
    Loader,
  },
  props: {
    message: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>

#loading {
  height: 100vh;
  width: 400px;
  margin: 0 auto;
  // border: 3px solid $border-color;
  padding: $content-padding;


  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .login-container {
    width: 100%;

    a {
      width: 100%;
    }
  }

  a {
    width: auto;
  }

  a.button, a.img-button {
    margin-bottom: 15px;
  }

  .digita-production {
    margin: 0 auto;
    color: $link-color;
  }

  p.info {
    text-align: center;
    margin-bottom: 15px;
  }

  p.error {
    color: red;
    text-align: center;
  }

  p.logo-text {
    margin-bottom: 0px;
    font-size: 2em;
    text-align: center;
    font-weight: 500;
    font-family: 'Avenir Next', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 500;
    color: $link-color;
  }
}
</style>
